var _style, _path, _path2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .storage-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "storage-st0",
    d: "M331.5,342V33.5c0-6.6-5.4-12-12-12h-279c-6.6,0-12,5.4-12,13V342l57-53.5h188L331.5,342z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "storage-st0",
    d: "M331.5,288.5c-36,0-58,0-58,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "storage-st0",
    d: "M288.5,323.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "storage-st0",
    x1: 28.5,
    y1: 288.5,
    x2: 85.5,
    y2: 288.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.bef19ab38ce0ada3dc1f3b3707da53d8.svg";
export { ForwardRef as ReactComponent };